import { registerLocaleData } from '@angular/common';
import localeId from '@angular/common/locales/id';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

registerLocaleData(localeId, 'id');

// Static hosting serves the prerendered home page as the SPA fallback for
// client-rendered routes (e.g. a product added after the last build).
// Hydrating that DOM against a different URL leaves stale home markup on
// screen. When the served page's canonical path doesn't match the current
// URL, discard the server DOM and serialized state so Angular does a clean
// client render, as if index.csr.html had been served.
const canonicalHref = document
  .querySelector('link[rel="canonical"]')
  ?.getAttribute('href');
if (canonicalHref) {
  const normalize = (path: string) => path.replace(/\/+$/, '') || '/';
  const renderedPath = normalize(
    new URL(canonicalHref, location.origin).pathname
  );
  if (renderedPath !== normalize(location.pathname)) {
    document
      .querySelector('fc-root')
      ?.replaceWith(document.createElement('fc-root'));
    document.getElementById('ng-state')?.remove();
  }
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
